{
  "adminSignInLink": {
    "body": "Nhấn vào nút bên dưới để truy cập cổng thông tin quản trị viên Pointcare của bạn.",
    "cta": "Đăng nhập quản trị viên",
    "greeting": "Xin chào,",
    "ignore": "Nếu bạn không yêu cầu quyền truy cập quản trị viên, bạn có thể bỏ qua email này.",
    "linkFallback": "Nếu nút không hoạt động, hãy sao chép và dán liên kết này:",
    "signoff": "Cảm ơn,\nĐội ngũ Pointcare",
    "subject": "Liên kết đăng nhập quản trị viên Pointcare của bạn"
  },
  "reset": {
    "body": "Chúng tôi đã nhận được yêu cầu đặt lại mật khẩu cho tài khoản Pointcare của bạn. Nhấn vào nút bên dưới để tạo mật khẩu mới.",
    "cta": "Đặt lại mật khẩu của tôi",
    "greeting": "Xin chào,",
    "ignore": "Nếu bạn không yêu cầu điều này, bạn có thể bỏ qua email này một cách an toàn. Mật khẩu của bạn sẽ không thay đổi.",
    "signoff": "Cảm ơn,\nĐội ngũ Pointcare",
    "subject": "Đặt lại mật khẩu Pointcare của bạn"
  },
  "signInLink": {
    "body": "Nhấn vào nút bên dưới để xác nhận email và thiết lập tài khoản Pointcare của bạn.",
    "cta": "Xác nhận email của tôi",
    "greeting": "Xin chào,",
    "ignore": "Bạn không đăng ký Pointcare? Bạn có thể bỏ qua email này.",
    "linkFallback": "Nếu nút không hoạt động, hãy sao chép và dán liên kết này:",
    "signoff": "Cảm ơn,\nĐội ngũ Pointcare",
    "subject": "Xác nhận email của bạn cho Pointcare"
  }
}
